import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

// Papelera del diseno: tapa con asa y dos lineas verticales dentro del cuerpo.
// Los iconos de borrar de MUI (DeleteOutline y companyia) no llevan esas lineas,
// asi que el trazado va a mano. Es un SvgIcon, de modo que hereda color y
// tamaño como cualquier otro icono.
export function TrashIcon(props: SvgIconProps) {
  return (
    // fill="none" va tambien en cada path, no solo en el sx del svg: MuiSvgIcon
    // trae `fill: currentColor` en su propia clase y los hijos lo heredan, con
    // lo que la papelera salia maciza en rojo en vez de dibujada a trazo.
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{ fill: 'none', ...props.sx }}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* tapa */}
      <line x1="3" y1="6" x2="21" y2="6" />
      {/* asa */}
      <path fill="none" d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      {/* cuerpo */}
      <path fill="none" d="M6 6v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6" />
      {/* las dos rayas de dentro */}
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </SvgIcon>
  )
}

export default TrashIcon
